import {Org} from "../../../resources/org"
import React from "react"
import TitleBar from "../../../components/TitleBar/TitleBar"
import {Customer} from "../../../resources/customer"
import MoveToUnitLive from "./MoveToUnitLive"
import {useListReturnPath} from "../../../hooks/useListReturnPath"

interface OrgPageProps {
	org: Org
	customers: Customer[]
	refresh: () => void
}
export default function OrgTitleBar({org, customers, refresh}: OrgPageProps) {
	const listReturnPath = useListReturnPath("/orgs/")
	const orgTitle = org ? org.attributes.name : "New Org"
	return (
		<TitleBar
			breadcrumbs={[{text: "Orgs", path: listReturnPath}]}
			title={orgTitle}
			meta={[]}
			noBorder
			status={
				org.attributes.isUnitPilot
					? {
							text: "Pilot",
							color: "#B0B2B5",
							backgroundColor: "#EBECEE",
					  }
					: undefined
			}
		>
			{org.attributes.isUnitPilot && <MoveToUnitLive org={org} customers={customers} refresh={refresh} />}
		</TitleBar>
	)
}
